import React from 'react';

interface Props {
    children: React.ReactNode;
}

const Container: React.FC<Props> = ({ children }) => {
    return (
        <main className="ac-page-content">
            <div className="public-panel text-left">
                <div className="public-panel-body">{children}</div>
            </div>
        </main>
    );
};

export default Container;
